<template>
  <div class='tablePage'>
    <el-table
      stripe
      v-loading='loading'
      ref='multipleTable'
      :data='tableData'
      tooltip-effect='dark'
      style='width: 100%'
      :header-cell-style='headCellStyle'
      :height='tableHeight'
      @selection-change='handleSelectionChange'
    >
      <el-table-column type='selection' width='50' />
      <el-table-column v-if='isSys' prop='scopeName' :label="$t('public.table_scope')" show-overflow-tooltip />
      <el-table-column prop='relayCode' :label="$t('integration.trunk_number')" show-overflow-tooltip width='200'>
        <template #default='{ row }'>
          <DeviceCode :device='row'>
            <template #icon='{device}'>
              <i v-icon:theme="['relayTypeConvert', device.type]" v-if='!$slots.icon'></i>
            </template>
            <template #name='{device}'>
              <el-popover placement='top-start' width='auto' trigger='hover'>
                <v-popoer :rowData='device' :typeWay='$attrs.sensorWay' />
                <span slot='reference' :class="{'bolder':device.status === ENUM_DEVICE_STATUS.OFFLINE}">
                           {{ device.relayCode }}
                        </span>
              </el-popover>
            </template>
          </DeviceCode>
        </template>
      </el-table-column>
      <el-table-column prop='updateTime' :label="$t('public.update_time')" show-overflow-tooltip>
        <template #default='{row}'>
          {{ $timetransition(row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column prop='description' :label="$t('integration.describe')" show-overflow-tooltip></el-table-column>
      <el-table-column prop='optare' fixed='right' :label="$t('public.table_operation')">
        <template #default='{ row }'>
          <div style='text-align:center;white-space: nowrap;'>
            <el-button type='text' size='small' v-for='item in optareBtn' :key='item.id' :title='$t(item.title)'
                       :icon='item.icon' @click='handle(item.method, row)'></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import prover from '../components/Proper.vue'
import { carrierTypeConvert, configStatusConvert, equiStatusConvert, relayTypeConvert } from '@/utils/convert'
import DeviceCode from '@/pages/equipment/publicCom/DeviceCode.vue'
import { ENUM_DEVICE_STATUS } from '@/common/enum/forward/device'
import { getPermission } from '@/utils/permission'

export default {
  props: ['loading', 'tableData'],
  computed: {
    ENUM_DEVICE_STATUS () {
      return ENUM_DEVICE_STATUS
    },
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    }
  },
  components: {
    DeviceCode,
    'v-popoer': prover
  },
  data () {
    return {
      relayTypeConvert,
      equiStatusConvert,
      configStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      optareBtn: [
        {
          id: 1,
          title: $t('public.stop'),
          icon: 'el-icon-video-pause',
          vHas: [],
          method: 'stopUseFn'
        },
        {
          id: 2,
          title: $t('public.config'),
          icon: 'el-icon-setting',
          vHas: [],
          method: 'configFn'
        },
        {
          id: 3,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        }
      ],
      isSys: true
    }
  },

  mounted () {
    if (this.sysAdmin === 'noSysIsAdmin' || this.sysAdmin === 'noSysNoAdmin') {
      this.isSys = false
    }
  },

  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    handle (method, row) {
      this.$emit(method, row)
    }
  }
}
</script>

<style lang='scss' scoped>
.tablePage {
  height: calc(100% - 60px);
}
</style>
